import * as React from 'react';
import { cn } from '../lib/utils';

export type StatusDotStatus = 'online' | 'offline' | 'pending' | 'error' | 'neutral';

const colors: Record<StatusDotStatus, string> = {
  online: 'bg-success',
  offline: 'bg-muted-foreground/60',
  pending: 'bg-warning',
  error: 'bg-destructive',
  neutral: 'bg-muted-foreground/40',
};

export interface StatusDotProps extends React.ComponentProps<'span'> {
  status: StatusDotStatus;
  /** Animate a soft pulse (used for "online" / "live" indicators). */
  pulse?: boolean;
  label?: string;
}

/** Small colored dot for online/offline/pending states, optionally pulsing. */
function StatusDot({ status, pulse = false, label, className, ...props }: StatusDotProps) {
  return (
    <span
      data-slot="status-dot"
      role={label ? 'img' : undefined}
      aria-label={label}
      className={cn('relative inline-flex size-2.5 shrink-0', className)}
      {...props}
    >
      {pulse ? (
        <span
          className={cn(
            'absolute inline-flex size-full animate-ping rounded-full opacity-60',
            colors[status],
          )}
        />
      ) : null}
      <span className={cn('relative inline-flex size-2.5 rounded-full', colors[status])} />
    </span>
  );
}

export { StatusDot };
